module.exports = __webpack_public_path__ + "img/couples-083.f1aacd6f.jpg";